/*
 * @Author: 何泽颖 hezeying@autowise.ai
 * @Date: 2024-05-15 13:12:39
 * @LastEditors: 何泽颖 hezeying@autowise.ai
 * @LastEditTime: 2024-05-15 20:47:52
 * @FilePath: /mbti-web/app/pediat/_components/Aside/index.jsx
 * @Description:相关人物侧边栏
 */
'use client';

import Avatar from '@/components/Avatar';
import { animated, useTrail } from '@react-spring/web';
import styles from './index.module.scss';

export default function Aside({ related }) {
  const trails = useTrail(related.length, {
    from: { opacity: 0 },
    to: { opacity: 1 },
  });

  return (
    <aside className={styles.pedia_aside}>
      <div className={styles.pedia_aside_title}>相关人物</div>

      <div className={styles.pedia_aside_related}>
        {trails.map((props, i) => {
          const {
            name = '',
            head = '',
            mbti_profile = '',
            mbti_type = 'ISFP',
            id = '',
          } = related[i];

          return (
            <animated.div
              style={props}
              className={styles.pedia_aside_related_item}
              key={id + name}
            >
              <Avatar
                head={head}
                name={name}
                mbti_profile={mbti_profile}
                id={id}
              />

              <div className={styles.info}>
                <div className={styles.info_name}>{name || mbti_profile}</div>
                <div className={styles.info_mbti}>{mbti_type}</div>
              </div>
            </animated.div>
          );
        })}
      </div>
    </aside>
  );
}
